import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { buyingGuideArticle } from '@/mocks/articles';

export default function BuyingGuidePage() {
  return <SeoArticlePage article={buyingGuideArticle} />;
}